import * as api from '../config/api';
import * as useAPI from './useAPI';
import { useState, useCallback } from 'react';

export const useBrokers = (): {
  brokers: useAPI.State<'state', api.GetUserBrokerResultItem[]>;
  getBrokers: (
    groupID?: number,
    From?: string,
    To?: string
  ) => Promise<api.GetUserBrokerResultItem[]>;
} => {
  const [brokers, setBrokers] = useState<
    useAPI.State<'state', api.GetUserBrokerResultItem[]>
  >(useAPI.loading);

  const getBrokers = useCallback(
    async (
      groupID?: number,
      From?: string,
      To?: string
    ): Promise<api.GetUserBrokerResultItem[]> => {
      const result = await api.getUserBroker(
        !groupID || groupID === 0 || groupID === 9999
          ? undefined
          : groupID.toString(),
        From ?? undefined,
        To ?? undefined
      );
      setBrokers(useAPI.loaded({ state: result.Items }));
      return result.Items;
    },
    []
  );
  return { brokers, getBrokers };
};
